import { Slide } from '@/components/core/Slide';
import profileImage from './02-jona.png';

export const slide = () => {
  return (
    <Slide
      notes="Introduction profile"
      transition="fade"
      visualizer="hidden"
      networkBackground="full"
    >
      <div className="relative z-10 flex items-center justify-center gap-12 h-full">
        <img src={profileImage} alt="Profile" className="h-[50vh] w-auto object-contain" />
        <p>
          Even voorstellen,
          <br />
          mijn naam is
          <br />
          <br />
          Jonathan IJzerman
        </p>
      </div>
    </Slide>
  );
};
